<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em">I want to celebrate the people who have helped me write “The Bear’s Cage Unlocked”.</p><br/>
<p style="text-indent:0em">Firstly, I must thank my wonderful wife, Amanda, who has always been an enthusiastic supporter of protecting the environment. Back in the late 1970s as a teenager, she lent me a paperback on environmental change. I was at Southampton University at the time, studying environmental law as part of my degree. I was completely drawn in and, worryingly, some forty or so years later, several of the predictions made in the book she lent me are already taking place.</p><br/>
<p style="text-indent:0em">For years I have carried the basic plotline of the story in my head, and Amanda encouraged me to put it down on paper, emailing me links to environmental developments and articles she had come across on the web. She lent me books from her growing library on environmental issues and we discussed the way we thought the climate might soon change. The thing that has struck us both is the speed with which climate change is now taking place. So, in a very real sense this book would not have been written without Amanda’s inspiration and enthusiasm. I also want to thank the team at Austin Macauley for their patience and support.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?b377cc22